import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TablePagination,
  Box
} from '@mui/material';

const ReportTable = ({ filteredData, page, rowsPerPage, setPage, setRowsPerPage }) => {
  return (
    // <Paper
    //   elevation={3}
    //   sx={{
    //     bgcolor: '#1e1e1e',
    //     p: 2,
    //     borderRadius: 2,
    //     color: '#fff',
    //     boxShadow: '0 2px 10px rgba(0,0,0,0.5)',
    //   }}
    // >
    //   <Typography variant="h5" sx={{ mb: 2, fontWeight: 'bold', color: 'white' }}>
    //     Ticket List
    //   </Typography>

    
            
    // </Paper>
    
    <>
    
      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          backgroundColor: 'transparent',
          maxHeight: 440,
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#8d8787' }}>
              <TableCell sx={{ fontWeight: 'bold' }}>#</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Ticket ID</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Title</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Department</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Assigned Staff</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Priority</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Date</TableCell>
              <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredData.length > 0 ? (
              filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((ticket, index) => (
                  <TableRow key={index} hover>
                    <TableCell sx={{ color: 'white' }}>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.ticketId}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.title}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.department}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.staff}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.priority}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.date}</TableCell>
                    <TableCell sx={{ color: 'white' }}>{ticket.status}</TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={8}>
                  <Typography variant="body2" align="center" sx={{ color: '#adb5bd', py: 2 }}>
                    No records found.
                  </Typography>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

     <Box
                      className="mui-wrapper mui-isolated-container p-0"
                        sx={{
                          color: "white",
                          px: 2,
                          py: 1,
                          display: 'flex',
                          justifyContent: 'flex-end',
                        
                          borderTop: '1px solid #ccc'
                        }}
                      >
                        <TablePagination
                        
                          rowsPerPageOptions={[5, 10, 25]}
                          component="div"
                    count={filteredData.length}
                rowsPerPage={rowsPerPage}
                          page={page}
                          onPageChange={(event, newPage) => setPage(newPage)}
                          onRowsPerPageChange={(event) => {
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                          }}
                          sx={{
                            background:"#8d8787",
                            borderRadius:"0px",
                            color: 'white !important',
                            '.MuiTablePagination-toolbar': {
                            m:0,  color: 'white',
                            },
                                 '.MuiTablePagination-toolbar': { color: 'white',overflow:{
                    xs:"scroll" ,
                    sm:"hidden" 
                  } },
                            '.MuiTablePagination-selectLabel, .MuiTablePagination-displayedRows': {
                              color: 'white !important',
                            }
                          }}
                        />
                      </Box>
    </>
  );
};

export default ReportTable;
